/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_Untitled_PortfolioInputs */

const en_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio`)
};

const de_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlageportfolio`)
};

const pt_br2_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfólio`)
};

const tr_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföy`)
};

const zh_cn2_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投资组合`)
};

const zh_hk2_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投資組合`)
};

const ko_kr2_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오`)
};

const ru_ru2_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Портфель`)
};

const es_419_onboarding_v1_pick_untitled_portfolio = /** @type {(inputs: Onboarding_V1_Pick_Untitled_PortfolioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portafolio`)
};

/**
* | output |
* | --- |
* | "Portfolio" |
*
* @param {Onboarding_V1_Pick_Untitled_PortfolioInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_untitled_portfolio = /** @type {((inputs?: Onboarding_V1_Pick_Untitled_PortfolioInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_Untitled_PortfolioInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "de") return de_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_untitled_portfolio(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_untitled_portfolio(inputs)
	return es_419_onboarding_v1_pick_untitled_portfolio(inputs)
});